import React, { createContext, useContext, useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const StripeContext = createContext();

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};

export const StripeProvider = ({ children }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Determine which publishable key to use based on mode
    const isTestMode = process.env.REACT_APP_STRIPE_MODE === 'test';
    const publishableKey = isTestMode 
      ? process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY 
      : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    
    if (!publishableKey) {
      const mode = isTestMode ? 'test' : 'live';
      console.warn(`⚠️  REACT_APP_STRIPE_${mode.toUpperCase()}_PUBLISHABLE_KEY not found. Stripe functionality will be limited.`);
      console.warn(`   Please add REACT_APP_STRIPE_${mode.toUpperCase()}_PUBLISHABLE_KEY to your .env.local file.`);
      console.warn(`   Current mode: ${mode}`);
      setStripePromise(null);
      setLoading(false);
      return;
    }
    
    console.log(`🔑 Stripe client initialized in ${isTestMode ? 'TEST' : 'LIVE'} mode`);
    const stripe = loadStripe(publishableKey);
    setStripePromise(stripe);
    setLoading(false);
  }, []);

  const value = {
    stripePromise,
    subscription,
    setSubscription,
    loading
  };

  return (
    <StripeContext.Provider value={value}>
      {children}
    </StripeContext.Provider>
  );
};
